import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Icons from 'lucide-react';
import { services } from '../mock';

const Services = () => {
  const { t } = useTranslation();
  
  const getIconComponent = (iconName) => {
    const IconComponent = Icons[iconName.split('-').map((word, index) => 
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join('').replace(/-/g, '')];
    return IconComponent || Icons.Package;
  };

  return (
    <section
      id="services"
      style={{
        background: '#0A1628',
        padding: '5rem 1.2rem',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Ayurvedic Herbs Background - Left Side */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '40%',
          height: '100%',
          backgroundImage: 'url(https://images.unsplash.com/photo-1730977806288-96b82f795008?q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.25,
          zIndex: 0,
        }}
      />
      
      {/* Tech Circuit Pattern - Right Side */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '40%',
          height: '100%',
          background: 'radial-gradient(circle at 80% 50%, rgba(6, 182, 212, 0.15) 0%, transparent 50%)',
          zIndex: 0,
        }}
      />
      
      {/* Data Grid Background */}
      <div className="data-grid-bg" />
      <div className="container">
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem', maxWidth: '800px', margin: '0 auto 3rem', position: 'relative', zIndex: 1 }}>
          <h2 className="heading-1" style={{ marginBottom: '1rem', color: 'var(--text-light)' }}>
            {t('services.title')}
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '2rem',
            position: 'relative',
            zIndex: 1,
          }}
        >
          {services.map((service, index) => {
            const IconComponent = getIconComponent(service.icon);
            const serviceIndex = index + 1;
            return (
              <div
                key={service.id}
                className={`service-card ${service.accentColor}`}
              >
                {/* Icon */}
                <div
                  className={`icon-container-${service.iconType}`}
                  style={{
                    width: '3.5rem',
                    height: '3.5rem',
                    borderRadius: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '1.25rem',
                    marginBottom: '1.25rem',
                  }}
                >
                  <IconComponent size={28} color="white" />
                </div>

                {/* Content */}
                <h3 className="heading-3" style={{ marginBottom: '0.75rem', color: 'var(--tech-green-300)' }}>
                  {t(`servicesPage.service${serviceIndex}.title`)}
                </h3>
                <p className="body-small" style={{ marginBottom: '1.5rem', color: 'var(--text-secondary)' }}>
                  {t(`servicesPage.service${serviceIndex}.description`)}
                </p>

                {/* Features List */}
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {[1, 2, 3, 4].map((featureNum) => (
                    <li
                      key={featureNum}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                      }}
                    >
                      <Icons.Check size={16} color="var(--tech-green-400)" />
                      <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                        {t(`servicesPage.service${serviceIndex}.feature${featureNum}`)}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
